module.exports = __webpack_public_path__ + "img/BG.e0e02e85.png";